import React, { useEffect, useMemo, useState } from 'react'
import { Box, BlockStack, InlineStack, Icon, Select, Divider, Button, Text, Tooltip, Badge } from '@shopify/polaris'
import { StatusActiveMajor, InfoMinor } from '@shopify/polaris-icons'
import { DIProps, DI } from '../../../../Core'
import { t } from 'i18next';
import getClass from '../../../Utilities/getClass';
import { CustomInfoIcon } from '../../../../Asests/svgIcon/icon';

interface Props extends DIProps {
    plan: any,
    planType: string,
    buyNowAction: (open: boolean, data: any) => void,
    activePlanName: any,
    activePlanData: any,
    activePlanID: any,
    planBadgeDetails: any
    setSettlementModal: (data: any) => void
}

const PricingCard = ({ plan, planType, buyNowAction, activePlanID, activePlanData, planBadgeDetails, activePlanName, setSettlementModal }: Props) => {
    // Memoized variation options
    const variationOptions = useMemo(() => {
        if (planType === "monthly" && plan?.has_variations) {
            return plan?.plans?.map((singleVariation: any, index: number) => ({
                label: `${singleVariation.variation.credits}`,
                value: singleVariation.variation.credits,
                index,
            })) || [];
        }
        return [];
    }, [plan, planType]);




    // Default to the first variation if available
    const [selectedVariation, setSelectedVariation] = useState<any | null>(null);

    useEffect(() => {
        if (variationOptions.length > 0 && plan?.plans?.length > 0) {
            const foundVariation =
                plan.plans.find((variation: any) => variation.plan_id === activePlanID) ||
                plan.plans.find(
                    (variation: any) => variation.plan_id === planBadgeDetails?.recommended?.plan_id
                ) ||
                plan.plans[0];

            setSelectedVariation(foundVariation);
        } else {
            setSelectedVariation(null);
        }
    }, [variationOptions, plan, activePlanID, planBadgeDetails]);

    const calculateBadgeValue = (plan: any) => {
        if (planBadgeDetails?.active?.plan_id == plan?.plan_id) {
            return <Badge tone='success-strong' size='medium'>{t("Current Plan")}</Badge>
        } else if (planBadgeDetails?.recommended?.plan_id == plan?.plan_id) {
            return <InlineStack align='end'>
                <Badge tone='warning-strong' size='medium'>{t(planBadgeDetails?.recommended?.tag)}</Badge>
            </InlineStack>
        }
    }

    const calculateCardHeighlight = (plan: any) => {
        if (activePlanID == plan?.plan_id) {
            return false;
        } else if (plan?.plan_id == planBadgeDetails?.recommended?.plan_id) {
            return true
        }
    }


    if (plan?.code === "free") {
        return (
            <div className='Custom-NewPricing--Card'>
                <Box background='bg-surface-selected' padding={"500"} borderRadius='300'>
                    <BlockStack gap={"500"}>
                        <BlockStack gap={"300"}>
                            <BlockStack gap={"800"}>
                                <BlockStack gap={"050"}>
                                    <Text as='p' variant='headingMd'><span className='fs-16'>{t(plan?.title)}</span></Text>
                                    <Text as='p' variant='bodyMd' tone='subdued'>{t(plan?.tagline.trim())}</Text>
                                </BlockStack>
                                <Text as='p' variant='heading2xl'>${plan?.custom_price}
                                    <Text as='span' variant='headingLg' tone='subdued' fontWeight='regular'> /{t("month")}</Text>
                                </Text>
                            </BlockStack>
                            <div style={{ height: "38px" , minHeight:"38px" }}></div>
                            <Divider borderColor='border' />
                            <BlockStack inlineAlign='start' gap={"200"}>
                                {plan?.features?.map((feature: any, ind: any) => (
                                    <InlineStack gap={"200"} key={ind} wrap={false} blockAlign='start'>
                                        <span><Icon source={StatusActiveMajor} tone="success" /></span>
                                        {feature?.description ? (
                                            <InlineStack gap={"050"}>
                                                <Text as="p" variant="bodyMd" fontWeight={"semibold"}>
                                                    {t(feature.feature)}
                                                </Text>
                                                <Tooltip content={t(feature?.description)}>
                                                    <Icon source={InfoMinor} />
                                                </Tooltip>
                                            </InlineStack>
                                        ) : (
                                            <Text as="p" variant="bodyMd" fontWeight={"regular"}>
                                                {t(feature.feature)}
                                            </Text>
                                        )}
                                    </InlineStack>
                                ))}
                            </BlockStack>
                        </BlockStack>
                        {
                            activePlanName === plan?.title && activePlanID == plan?.plan_id ?
                                <div
                                    onMouseLeave={() => {
                                        // let tempYearlyPrimary = { ...buttonPrimary };
                                        // tempYearlyPrimary[plan?.plan_id] = false;
                                        // setButtonPrimary({ ...tempYearlyPrimary });
                                    }}
                                    className='custom-pricing-btn__wrapper'
                                >
                                    <Button
                                        size='large'
                                        fullWidth
                                        onMouseEnter={() => {
                                            // let tempYearlyPrimary = { ...buttonPrimary };
                                            // tempYearlyPrimary[plan?.plan_id] = true;
                                            // setButtonPrimary({ ...tempYearlyPrimary });
                                        }}
                                        // loading={buttonLoading[plan?.plan_id]}
                                        // variant={buttonPrimary[plan?.plan_id] ? 'primary' : undefined}
                                        disabled={plan?.title === activePlanName || plan?.active == false}
                                        onClick={() => {

                                            !activePlanData?.user_service?.postpaid?.is_capped && activePlanData?.settlement_info && Object.values(activePlanData?.settlement_info).length > 0 ?
                                                setSettlementModal({
                                                    open: true,
                                                    planId: plan?.plan_id,
                                                    data: activePlanData?.settlement_info
                                                })
                                                :
                                                // plan?.title === 'Free' ?
                                                // choosePlan(plan?.plan_id, 'Free') :
                                                // choosePlan(plan?.plan_id)
                                                buyNowAction(
                                                    true,
                                                    plan
                                                )
                                        }
                                        }
                                    >
                                        {t("Current Plan")}
                                    </Button>
                                </div>
                                :
                                plan?.title == activePlanName &&
                                    plan?.plan_id == activePlanID ||
                                    plan?.active == false ?
                                    <div
                                        onMouseLeave={() => {
                                            // let tempYearlyPrimary = { ...buttonPrimary };
                                            // tempYearlyPrimary[plan?.plan_id] = false;
                                            // setButtonPrimary({ ...tempYearlyPrimary });
                                        }}
                                        className='custom-pricing-btn__wrapper'
                                    >
                                        <Tooltip content={(plan?.active == false && plan?.message && plan?.message !== "") ? plan?.message : t('Plan unavailable due to lower order limit than current order usage')} dismissOnMouseOut>
                                            <Button
                                                size='large'
                                                fullWidth
                                                onMouseEnter={() => {
                                                    // let tempYearlyPrimary = { ...buttonPrimary };
                                                    // tempYearlyPrimary[plan?.plan_id] = true;
                                                    // setButtonPrimary({ ...tempYearlyPrimary });
                                                }}
                                                // loading={buttonLoading[plan?.plan_id]}
                                                // variant={buttonPrimary[plan?.plan_id] || plan?.badge !== '' ? 'primary' : undefined}
                                                disabled={
                                                    plan?.title == activePlanName &&
                                                    plan?.plan_id == activePlanID ||
                                                    plan?.active == false
                                                }
                                                onClick={() => {
                                                    !activePlanData?.user_service?.postpaid?.is_capped && activePlanData?.settlement_info && Object.values(activePlanData?.settlement_info).length > 0 ?
                                                        setSettlementModal({
                                                            open: true,
                                                            planId: plan?.plan_id,
                                                            data: activePlanData?.settlement_info
                                                        })
                                                        :
                                                        // plan?.title === 'Free' ?
                                                        // choosePlan(plan?.plan_id, 'Free') :
                                                        // choosePlan(plan?.plan_id)
                                                        buyNowAction(
                                                            true,
                                                            plan
                                                        )
                                                }
                                                }
                                            >
                                                {
                                                    plan?.title?.toLowerCase() === 'Free' ? t("Try For Free") :
                                                        t("Get Started")
                                                }
                                            </Button>
                                        </Tooltip>
                                    </div>
                                    :
                                    <div
                                        onMouseLeave={() => {
                                            // let tempMonthlyPrimary = { ...buttonPrimary };
                                            // tempMonthlyPrimary[plan?.plan_id] = false;
                                            // setButtonPrimary({ ...tempMonthlyPrimary });
                                        }}
                                        className='custom-pricing-btn__wrapper'
                                    >
                                        <Button
                                            size='large'
                                            fullWidth
                                            onMouseEnter={() => {
                                                // let tempMonthlyPrimary = { ...buttonPrimary };
                                                // tempMonthlyPrimary[plan?.plan_id] = true;
                                                // setButtonPrimary({ ...tempMonthlyPrimary });
                                            }}
                                            // loading={buttonLoading[plan?.plan_id]}
                                            // variant={buttonPrimary[plan?.plan_id] ? 'primary' : undefined}
                                            disabled={
                                                plan?.title == activePlanName &&
                                                plan?.plan_id == activePlanID ||
                                                plan?.active == false
                                            }
                                            onClick={() => {
                                                !activePlanData?.user_service?.postpaid?.is_capped && activePlanData?.settlement_info && Object.values(activePlanData?.settlement_info).length > 0 ?
                                                    setSettlementModal({
                                                        open: true,
                                                        planId: plan?.plan_id,
                                                        data: activePlanData?.settlement_info
                                                    })
                                                    :
                                                    // plan?.title === 'Free' ?
                                                    // choosePlan(plan?.plan_id, 'Free') :
                                                    // choosePlan(plan?.plan_id)
                                                    buyNowAction(
                                                        true,
                                                        plan
                                                    )
                                            }}
                                        >
                                            {t("Get Started")}
                                        </Button>
                                    </div>
                        }
                    </BlockStack>
                </Box>
            </div>
        );
    }
    return (
        <div className={getClass({ "Custom-NewPricing--Card": true, "Custom-NewPricing--Card--current-plan": planBadgeDetails?.active?.plan_id == selectedVariation?.plan_id , "Custom-NewPricing--Card--recomm-plan": planBadgeDetails?.recommended?.plan_id == selectedVariation?.plan_id })}>
            {selectedVariation &&<Box background={calculateCardHeighlight(selectedVariation) ? "bg-inverse" : 'bg-surface-selected'} padding={"500"} borderRadius="300">
                <BlockStack gap={"500"}>
                    <BlockStack gap={"300"}>
                        <BlockStack gap={"800"}>
                            <BlockStack gap={"050"}>
                                <InlineStack gap={"300"} align='space-between'>
                                    <Text tone={calculateCardHeighlight(selectedVariation) ? 'text-inverse' : undefined} as="span" variant="headingMd">
                                        <span className="fs-16">{t(selectedVariation?.title) || t(plan.title)}</span>
                                    </Text>
                                    {calculateBadgeValue(selectedVariation)}
                                    {/* {calculateCardHeighlight(selectedVariation) && <Badge tone='warning-strong' size='medium'>Most Popular</Badge>} */}
                                </InlineStack>
                                <Text tone={calculateCardHeighlight(selectedVariation) ? 'text-inverse' : undefined} as="p" variant="bodyMd">
                                    {t(selectedVariation?.tagline.trim()) || t(plan.tagline.trim())}
                                </Text>
                            </BlockStack>
                            <Text tone={calculateCardHeighlight(selectedVariation) ? 'text-inverse' : undefined} as="p" variant="heading2xl">
                                ${selectedVariation?.variation?.price || plan.custom_price}
                                <Text tone={calculateCardHeighlight(selectedVariation) ? 'text-inverse' : undefined} as="span" variant="headingLg" fontWeight="regular">
                                    {" "}
                                    /{t("month")}
                                </Text>
                            </Text>
                        </BlockStack>

                        {variationOptions.length > 0 && (
                            <InlineStack gap={"300"} blockAlign="center">
                                <div className="flex-1 custom-pricing-selecr__wrapper">
                                    <Select
                                        label=""
                                        labelHidden
                                        options={variationOptions}
                                        value={selectedVariation?.variation?.credits}
                                        placeholder={t("Select Order")}
                                        onChange={(value) => {
                                            setSelectedVariation(plan.plans.find(
                                                (v: any) => v.variation.credits === parseInt(value)
                                            ));
                                        }}
                                    />
                                </div>
                                <span style={{maxWidth : "64px"}}>
                                    <Text tone={calculateCardHeighlight(selectedVariation) ? 'text-inverse' : 'subdued'} as="p" variant="bodyMd" fontWeight="regular">
                                        {t("Orders per month")}
                                    </Text>
                                </span>
                            </InlineStack>
                        )}

                        <Divider borderColor={planBadgeDetails?.recommended?.plan_id == selectedVariation?.plan_id ? "border-inverse":"border"} />
                        <BlockStack inlineAlign="start" gap={"200"}>
                            {selectedVariation?.features?.map((feature: any, ind: number) =>
                                feature?.card_visiblity && (
                                    <InlineStack gap={"200"} key={ind} wrap={false} blockAlign='start'>
                                        <span><Icon source={StatusActiveMajor} tone="success" /></span>
                                        {feature?.description ? (
                                            <InlineStack gap={"050"}>
                                                <Text tone={calculateCardHeighlight(selectedVariation) ? 'text-inverse' : undefined} as="p" variant="bodyMd" fontWeight={"semibold"}>
                                                    {t(feature.feature.trim())}
                                                </Text>
                                                <Tooltip content={t(feature?.description)}>
                                                    <span className='custom-icon-with-text'><CustomInfoIcon color={planBadgeDetails?.recommended?.plan_id == selectedVariation?.plan_id ? "#E3E3E3":"#4A4A4A"}/></span>
                                                    {/* <Icon source={InfoMinor} tone={planBadgeDetails?.recommended?.plan_id == selectedVariation?.plan_id ? "subdued":"base"}/> */}
                                                </Tooltip>
                                            </InlineStack>
                                        ) : (
                                            <Text tone={calculateCardHeighlight(selectedVariation) ? 'text-inverse' : undefined} as="p" variant="bodyMd" fontWeight={"regular"}>
                                                {t(feature.feature.trim())}
                                            </Text>
                                        )}
                                    </InlineStack>
                                )
                            )}
                        </BlockStack>
                    </BlockStack>

                    {
                        activePlanName === selectedVariation?.title && activePlanID == selectedVariation?.plan_id ?
                            <div
                                onMouseLeave={() => {
                                    // let tempYearlyPrimary = { ...buttonPrimary };
                                    // tempYearlyPrimary[plan?.plan_id] = false;
                                    // setButtonPrimary({ ...tempYearlyPrimary });
                                }}
                                className='custom-pricing-btn__wrapper'
                            >
                                <Button
                                    size='large'
                                    fullWidth
                                    onMouseEnter={() => {
                                        // let tempYearlyPrimary = { ...buttonPrimary };
                                        // tempYearlyPrimary[plan?.plan_id] = true;
                                        // setButtonPrimary({ ...tempYearlyPrimary });
                                    }}
                                    // loading={buttonLoading[plan?.plan_id]}
                                    // variant={buttonPrimary[plan?.plan_id] ? 'primary' : undefined}
                                    disabled={selectedVariation?.title === activePlanName || selectedVariation?.active == false}
                                    onClick={() => {
                                        !activePlanData?.user_service?.postpaid?.is_capped && activePlanData?.settlement_info && Object.values(activePlanData?.settlement_info).length > 0 ?
                                            setSettlementModal({
                                                open: true,
                                                planId: plan?.plan_id,
                                                data: activePlanData?.settlement_info
                                            })
                                            :
                                            // plan?.title === 'Free' ?
                                            // choosePlan(plan?.plan_id, 'Free') :
                                            // choosePlan(plan?.plan_id)
                                            buyNowAction(
                                                true,
                                                selectedVariation
                                            )
                                    }
                                    }
                                >
                                    {t("Current Plan")}
                                </Button>
                            </div>
                            :
                            selectedVariation?.title == activePlanName &&
                                selectedVariation?.plan_id == activePlanID ||
                                selectedVariation?.active == false ?
                                <div
                                    onMouseLeave={() => {
                                        // let tempYearlyPrimary = { ...buttonPrimary };
                                        // tempYearlyPrimary[plan?.plan_id] = false;
                                        // setButtonPrimary({ ...tempYearlyPrimary });
                                    }}
                                    className='custom-pricing-btn__wrapper'
                                >
                                    <Tooltip content={(selectedVariation?.active == false && selectedVariation?.message && selectedVariation?.message !== "") ? selectedVariation?.message : t('Plan unavailable due to lower order limit than current order usage')} dismissOnMouseOut>
                                        <Button
                                            size='large'
                                            fullWidth
                                            onMouseEnter={() => {
                                                // let tempYearlyPrimary = { ...buttonPrimary };
                                                // tempYearlyPrimary[plan?.plan_id] = true;
                                                // setButtonPrimary({ ...tempYearlyPrimary });
                                            }}
                                            // loading={buttonLoading[plan?.plan_id]}
                                            // variant={buttonPrimary[plan?.plan_id] || plan?.badge !== '' ? 'primary' : undefined}
                                            disabled={
                                                selectedVariation?.title == activePlanName &&
                                                selectedVariation?.plan_id == activePlanID ||
                                                selectedVariation?.active == false
                                            }
                                            onClick={() => {

                                                !activePlanData?.user_service?.postpaid?.is_capped && activePlanData?.settlement_info && Object.values(activePlanData?.settlement_info).length > 0 ?
                                                    setSettlementModal({
                                                        open: true,
                                                        planId: plan?.plan_id,
                                                        data: activePlanData?.settlement_info
                                                    })
                                                    :
                                                    // plan?.title === 'Free' ?
                                                    // choosePlan(plan?.plan_id, 'Free') :
                                                    // choosePlan(plan?.plan_id)
                                                    buyNowAction(
                                                        true,
                                                        selectedVariation
                                                    )
                                            }
                                            }
                                        >
                                            {
                                                selectedVariation?.title?.toLowerCase() === 'Free' ? t("Try For Free") :
                                                    t("Buy Now")
                                            }
                                        </Button>
                                    </Tooltip>
                                </div>
                                :
                                <div
                                    onMouseLeave={() => {
                                        // let tempMonthlyPrimary = { ...buttonPrimary };
                                        // tempMonthlyPrimary[plan?.plan_id] = false;
                                        // setButtonPrimary({ ...tempMonthlyPrimary });
                                    }}
                                    className='custom-pricing-btn__wrapper'
                                >
                                    <Button
                                        size='large'
                                        fullWidth
                                        onMouseEnter={() => {
                                            // let tempMonthlyPrimary = { ...buttonPrimary };
                                            // tempMonthlyPrimary[plan?.plan_id] = true;
                                            // setButtonPrimary({ ...tempMonthlyPrimary });
                                        }}
                                        // loading={buttonLoading[plan?.plan_id]}
                                        // variant={buttonPrimary[plan?.plan_id] ? 'primary' : undefined}
                                        disabled={
                                            selectedVariation?.title == activePlanName &&
                                            selectedVariation?.plan_id == activePlanID ||
                                            selectedVariation?.active == false
                                        }
                                        onClick={() => {

                                            !activePlanData?.user_service?.postpaid?.is_capped && activePlanData?.settlement_info && Object.values(activePlanData?.settlement_info).length > 0 ?
                                                setSettlementModal({
                                                    open: true,
                                                    planId: plan?.plan_id,
                                                    data: activePlanData?.settlement_info
                                                })
                                                :
                                                // plan?.title === 'Free' ?
                                                // choosePlan(plan?.plan_id, 'Free') :
                                                // choosePlan(plan?.plan_id)
                                                buyNowAction(
                                                    true,
                                                    selectedVariation
                                                )
                                        }}
                                    >
                                        {t("Buy Now")}
                                    </Button>
                                </div>
                    }
                </BlockStack>
            </Box>}
        </div>
    );
};

export default DI(PricingCard);
